import { useAuth0 } from "@auth0/auth0-react";
import SureLoader from '../Components/SureLoader';

function AuthGuard({ children }) {
    const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();

    if (isLoading) {
        return <SureLoader fullscreen/>;
    }

    if (error) {
        return <div>Oops... {error.message}</div>;
    }

    // Instead of immediately calling loginWithRedirect(),
    // we redirect to our own login page
    if (!isAuthenticated) {
        // Immediately send the user to Auth0 Universal Login
       loginWithRedirect();
       return null; // or a loader/spinner, so we don't render child routes
    }

    return <>{children}</>;
}

export default AuthGuard;